

export class DocumentExchange {

	id = "";
	memberRecipientId = "";
	category = "";
	categoryName = "";

	description = "";
	date: null|number = null;
	dateFirstRead: null|number = null;
	bSeen = true;

	files: { id: string, filename: string }[] = [];

	anMitglied = false;
	memberSenderId = "";

	bOwn: boolean|null = null;

}

export class DocumentExchangeB {

	austauschId = "";
	agId = "";	// category id

	empfaengerMitgliedId = "";	// mitgliedId

	beschreibung = "";
	austauschDatum: number|null = null;
	erstesGelesenDatum: number|null = null;
	gelesen = true;

	anMitglied = false;
	absenderMitgliedId = "";

	verarbeitet = false;
	meldung = "";
	status: any = null;
	austausch: {
		austauschId: string;
		agId: string;
		beschreibung: string;
		aenderungsBenutzer: string;
		aenderungsDatum: number;
		anlageBenutzer: string;
		anlageDatum: number;
		austauschDatum: number;
		anMitglied: boolean;
		empfaengerMitgliedId: string | null;
		gelesen: boolean | null;
	} = {
		austauschId: "",
		agId: "",
		beschreibung: "",
		aenderungsBenutzer: "",
		aenderungsDatum: 0,
		anlageBenutzer: "",
		anlageDatum: 0,
		austauschDatum: 0,
		anMitglied: false,
		empfaengerMitgliedId: null,
		gelesen: null
	};

}

export class DocumentExchangeCategory {

	id = "";
	name = "";
	description = "";
	email = false;
	agSubmenu = false;

}

export class DocumentExchangeCategoryB {

	agId = "";
	agName = "";
	agBeschreibung = "";
	erinerungsmail = false;
	agSubmenu = false;

}


export class MyDEFile {

	id = "";
	file: File|null = null;

}